var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grey",
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,16 C12.8659932,16 16,12.8659932 16,9 C16,5.13400675 12.8659932,2 9,2 C5.13400675,2 2,5.13400675 2,9 C2,12.8659932 5.13400675,16 9,16 Z M9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 Z",
    id: "Oval-4",
    fillRule: "nonzero",
    transform: "translate(9.000000, 9.000000) rotate(-270.000000) translate(-9.000000, -9.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6738349,9.7474945 C11.813344,9.6079854 11.813344,9.38477085 11.6738349,9.24526176 L7.53320495,5.10463182 C7.39369586,4.96512273 7.17048131,4.96512273 7.03097221,5.10463182 L6.10463182,6.03097221 C5.96512273,6.17048131 5.96512273,6.39369586 6.10463182,6.53320495 L9.067805,9.49637813 L6.10463182,12.4595513 C5.96512273,12.5990604 5.96512273,12.8222749 6.10463182,12.961784 L7.03097221,13.8881244 C7.17048131,14.0276335 7.39369586,14.0276335 7.53320495,13.8881244 L11.6738349,9.7474945 Z",
    id: "\\uF054",
    transform: "translate(8.889233, 9.496378) rotate(-270.000000) translate(-8.889233, -9.496378) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.21345d8f09ac948a3f47adb1e49449f8.svg";
export { ForwardRef as ReactComponent };